import { useContext } from 'react'
import { DataContext, DataProviderContext } from '../providers/data'

export const useData = (): DataProviderContext => useContext(DataContext)

export default useData
